import { Scopes, createServiceModule } from '@aesop-fables/containr';
import { IsAuthenticated } from './IsAuthenticated';
import { UserRolesInitialized } from './UserRolesInitialized';
import { Predicates } from './Types';
import { UserInitialized } from './UserInitialized';
import { GroupAdminRolesResolved } from './GroupAdminRolesResolved';
import { GroupFeatureMapInitialized } from './GroupFeatureMapInitialized';
import { GroupRevenueAccessResolved } from './GroupRevenueAccessResolved';
import { GroupSelected } from './GroupSelected';
import { TeamSelected } from './TeamSelected';
import { OrgAdminRolesResolved } from './OrgAdminRolesResolved';
import { TeamAdminRolesResolved } from './TeamAdminRolesResolved';
import { TeamRevenueAccessResolved } from './TeamRevenueAccessResolved';
import { OrganizationSelected } from './OrganizationSelected';
import { OrgAvailablePricebooksInitialized } from './OrgAvailablePricebooksInitialized';
import { SubscriptionInitialized } from './SubscriptionInitialized';
import { TeamAvailablePricebooksInitialized } from './TeamAvailablePricebooksInitialized';
import { LicenseAgreementInitialized } from './LicenseAgreementInitialized';
import { PricebooksSelected } from './PricebooksSelected';
import { RevenueAccessResolved } from './RevenueAccessResolved';
import { LmsEnabled } from './LmsEnabled';

export const usePredicateServiceModule = createServiceModule('PredicateServiceModule', services => {
  services.autoResolve(Predicates.IsAuthenticated, IsAuthenticated, Scopes.Singleton);
  services.autoResolve(
    Predicates.GroupAdminRolesResolved,
    GroupAdminRolesResolved,
    Scopes.Singleton,
  );
  services.autoResolve(
    Predicates.GroupFeatureMapInitialized,
    GroupFeatureMapInitialized,
    Scopes.Singleton,
  );
  services.autoResolve(
    Predicates.GroupRevenueAccessResolved,
    GroupRevenueAccessResolved,
    Scopes.Singleton,
  );
  services.autoResolve(Predicates.GroupSelected, GroupSelected, Scopes.Singleton);
  services.autoResolve(
    Predicates.LicenseAgreementInitialized,
    LicenseAgreementInitialized,
    Scopes.Singleton,
  );
  services.autoResolve(Predicates.LmsEnabled, LmsEnabled, Scopes.Singleton);
  services.autoResolve(
    Predicates.OrgAvailablePricebooksInitialized,
    OrgAvailablePricebooksInitialized,
    Scopes.Singleton,
  );
  services.autoResolve(Predicates.OrgAdminRolesResolved, OrgAdminRolesResolved, Scopes.Singleton);
  services.autoResolve(Predicates.OrganizationSelected, OrganizationSelected, Scopes.Singleton);
  services.autoResolve(Predicates.PricebooksSelected, PricebooksSelected, Scopes.Singleton);
  services.autoResolve(
    Predicates.RevenueAccessResolved,
    RevenueAccessResolved,
    Scopes.Singleton,
  );
  services.autoResolve(
    Predicates.TeamAvailablePricebooksInitialized,
    TeamAvailablePricebooksInitialized,
    Scopes.Singleton,
  );
  services.autoResolve(
    Predicates.SubscriptionInitialized,
    SubscriptionInitialized,
    Scopes.Singleton,
  );
  services.autoResolve(Predicates.TeamSelected, TeamSelected, Scopes.Singleton);
  services.autoResolve(Predicates.TeamAdminRolesResolved, TeamAdminRolesResolved, Scopes.Singleton);
  services.autoResolve(
    Predicates.TeamRevenueAccessResolved,
    TeamRevenueAccessResolved,
    Scopes.Singleton,
  );
  services.autoResolve(Predicates.UserInitialized, UserInitialized, Scopes.Singleton);
  services.autoResolve(Predicates.UserRolesInitialized, UserRolesInitialized, Scopes.Singleton);
});
